import { apiClient } from "./config/serviceConfiguration";

export default {
  getAllPaymentMethods() {
    return apiClient.get("/payment-methods");
  },
};
